import React, { useRef, useState, useEffect } from 'react';
import Banner from '../components/Banner/Banner';
import Coordinates from '../containers/Contact/Coordinates/Coordinates';
import ContactOptions from '../containers/Contact/ContactOptions/ContactOptions';
import Form from '../components/Form/Form';
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import Layout from '../components/Layout';
import Head from 'next/head';
import { getAllServicesWithSlug, getContactPage } from '../utils/api';

gsap.registerPlugin(ScrollTrigger);

const contact = ({ contact, services }) => {
  const headerRef = useRef(null);

  const [active, setActive] = useState(null);

  useEffect(() => {
    if (ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }, [active]);

  return (
    <Layout pathRoot={'Contact'}>
      <Head>
        <link
          href='https://api.mapbox.com/mapbox-gl-js/v2.3.1/mapbox-gl.css'
          rel='stylesheet'
        />
      </Head>

      <Banner
        title={contact.title}
        banner={contact.headerBackground?.url}
        headerRef={headerRef}
      />

      <Coordinates
        phone={contact.phone}
        address={contact.address}
        hours={contact.hours}
        linkLinkedIn={contact.linkLinkedIn}
      />
      <ContactOptions
        setActive={setActive}
        contactCompanyTitle={contact.contactCompanyTitle}
        contactCompanyAbstract={contact.contactCompanyAbstract?.json}
        contactProjectTitle={contact.contactProjectTitle}
        contactProjectAbstract={contact.contactProjectAbstract?.json}
        contactSupportTitle={contact.contactSupportTitle}
        contactSupportAbstract={contact.contactSupportAbstract?.json}
      />

      {active && (
        <Form
          background='#FAFAFA'
          padding='0 0 100px 0'
          formBackground='#fff'
          color={active.color}
          type={active.type}
          handleClose={() => setActive(null)}
          services={services}
        />
      )}
    </Layout>
  );
};

export default contact;

export async function getStaticProps({ params }) {
  const data = await getContactPage();
  const services = await getAllServicesWithSlug();

  return {
    props: {
      contact: data ?? null,
      services: services ?? [],
    },
  };
}
